import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { forkJoin, Subject } from 'rxjs';
import { ServiceAbonnementService, TilvalgService } from 'src/app/api/services';
import { ServiceabonnementTilvalgRelationDialogData } from 'src/app/components/aftale/models';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';
import { TilvalgEditDialogComponent } from '../../tilvalg/tilvalg-edit-dialog/tilvalg-edit-dialog.component';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ServiceAbonnementDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/service-abonnement-dto';
import { TilvalgDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/tilvalg-dto';
import { TilvalgGroupDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/tilvalg-group-dto';
import { takeUntil, finalize } from 'rxjs/operators';
@Component({
    selector: 'app-serviceabonnement-tilvalg-relation-dialog',
    templateUrl: './serviceabonnement-tilvalg-relation-dialog.component.html',
    styleUrls: ['./serviceabonnement-tilvalg-relation-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ServiceabonnementTilvalgRelationDialogComponent implements OnInit {
  serviceabonnement: ServiceAbonnementDto;
  selectedTilvalgGroups: TilvalgGroupDto[];
  tilvalgGroups: TilvalgGroupDto[];

  tilvalg: TilvalgDto[];
  selectedTilvalg: TilvalgDto[];

  hasChanges: boolean = false;

  unsubscribe$ = new Subject<void>();

  constructor(
    private tilvalgService: TilvalgService,
    private serviceabonnementService: ServiceAbonnementService,
    private loader: LoaderService,
    private errorHandler: ErrorHandlerService,
    public dialogRef: MatDialogRef<TilvalgEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ServiceabonnementTilvalgRelationDialogData
  ) {
    this.serviceabonnement = data.serviceabonnement;
  }

  ngOnInit(): void {
    this.loader.show();
    forkJoin([
      this.tilvalgService.getTilvalgGroupsForServiceabonnement({
        caller: EGIS_SERVICE_CALLER,
        serviceAbonnementId: this.serviceabonnement.id,
      }),
      this.tilvalgService.getTilvalgGroups({
        caller: EGIS_SERVICE_CALLER,
      }),
    ])
      .pipe(
        takeUntil(this.unsubscribe$),
        finalize(() => {
          this.loader.hide();
        })
      )
      .subscribe(
        (response) => {
          this.selectedTilvalgGroups = response[0];
          this.tilvalgGroups = response[1];
          this.selectedTilvalg = this.flattenTilvalg(this.selectedTilvalgGroups);

          let allTilvalg = this.flattenTilvalg(this.tilvalgGroups);

          const remainingTilvalg = allTilvalg.filter((tilvalg) => {
            const i = this.selectedTilvalg.findIndex((x) => x.tilvalgnr == tilvalg.tilvalgnr);
            return i < 0;
          });

          this.tilvalg = remainingTilvalg;
        },
        (error) => {
          this.errorHandler.HandleError(error);
        }
      );
  }

  submit() {
    const tilvalgNrList = this.selectedTilvalg.map((x) => x.tilvalgnr);
    this.loader.show();
    this.serviceabonnementService
      .updateTilvalgOnServiceabonnement({
        caller: EGIS_SERVICE_CALLER,
        body: {
          serviceabonnementId: this.serviceabonnement.id,
          tilvalgNrList: tilvalgNrList,
        },
      })
      .pipe(
        finalize(() => {
          this.loader.hide();
        }),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(
        (response) => {
          this.dialogRef.close(response);
        },
        (error) => {
          this.errorHandler.HandleError(error);
        }
      );
  }

  flattenTilvalg(tilvalgGroups: TilvalgGroupDto[]) {
    let tilvalgList: TilvalgDto[] = [];
    tilvalgGroups.forEach((tilvalgGroup: TilvalgGroupDto) => {
      tilvalgGroup.tilvalg.forEach((tilvalg: TilvalgDto) => {
        tilvalgList.push(tilvalg);
      });
    });
    return tilvalgList;
  }

  drop(event: CdkDragDrop<Array<any>>) {
    const item = event.previousContainer.data[event.previousIndex] as TilvalgDto;
    console.log('drop', item);
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
      this.hasChanges = true;
    }
  }
}
